export default "__VITE_ASSET__5edee0ac__"